/**
 * Maps a flow-specific run status (scheduled `EnrichmentJobStatus` or the
 * experiment `ExperimentPipelineStatus`) to the normalized `EnrichmentRunStatus`
 * the control rail gates on, so `deriveEnrichmentActions` stays flow-agnostic.
 */
import type { EnrichmentRunStatus } from '../types/workflow-control.types';

/** Collapse the various backend status tokens into RUNNING / FAILED / COMPLETED
 *  / UNKNOWN. Terminal-but-not-failed states (COMPLETED / AWAITING_APPROVAL /
 *  REJECTED / SKIPPED) map to COMPLETED — the rail only needs "can this still
 *  be paused/retried", not the exact lifecycle phase. */
export function normalizeRunStatus(status: string | null | undefined): EnrichmentRunStatus {
  switch (status) {
    case 'IN_PROGRESS':
    case 'PENDING':
      return 'RUNNING';
    case 'FAILED':
      return 'FAILED';
    case 'COMPLETED':
    case 'AWAITING_APPROVAL':
    case 'REJECTED':
    case 'SKIPPED':
      return 'COMPLETED';
    default:
      return 'UNKNOWN';
  }
}
